import { css } from "@emotion/react";

export const styFormContainer = css`
  margin: 16px 0;
`;

export const styWishListConatiner = css`
  margin: 40px 0;
  max-height: 350px;
  overflow: auto;
`;

export const styWishesCard = css`
  background-color: #fff;
  position: relative;
  min-height: 32px;
  padding: 10px 15px 6px !important;
  margin-top: 15px !important;
  border-radius: 4px;
  list-style: none outside none !important;
  border: 1px solid #a99d87 !important;
  text-align: left;
  word-break: break-word;

  p {
    margin: 0;
  }

  .name {
    font-weight: 600;
  }

  .message {
    margin: 8px 0;
  }

  .timestamp {
    font-size: 10px;
    text-align: right;
  }
`;
